import { isObject } from 'lodash';

/**
 * Factory function to append extra properties to the products models
 * @param  {IProduct[]} products - products collection
 * @param {object} data - values that will be used to eventually extend the product object
 * @returns {IProduct[] | ICooperativeProduct[]}
 */
export default function productsFactoryMiddleware(products, data = {}) {
    if (Array.isArray(products)) {
        return products.map(p => Object.assign(p, data));
    }

    return products;
}

/**
 * Factory function to append extra properties to the product model
 * @param  {object|object} product - products collection
 * @param {object} data - values that will be used to eventually extend the product object
 */
export function productFactoryMiddleware(product, data = {}) {
    if (isObject(product)) {
        return Object.assign(product, data);
    }

    return product;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/products-factory-middleware.js